import { TOAST } from "@commoncore/constants/ToastMessages";
import { LocalStorageProps } from "@commoncore/enums/localStorageProps";
import { SessionStorageProps } from '@commoncore/enums/sessionStorageProps';
import { AppEvents, EventsList } from "@commoncore/utils/app-events";
import { ENV_CONSTANTS, environment } from "@env-properties/environment";
import { ENV_CONFIG } from "@env-properties/environment-config";
import { USER_DETAILS } from "@mainrepo/app/core/constants/Constants";

import { InviteLinkController } from "projects/inviterepo/src/app/core/Controllers/InviteLinkController";
import { GlobalClassInstance } from "../constants/GlobalClass";
import { UserLoginImplementation } from "../implementation/UserLoginImplementation";
import { GlobalService } from "../services/global.service";
import { LocalStorageSvc } from "../services/localStorage.service";
import { ActiveRepo, UniversalService } from "../services/universal.service";
import { AppSettingController } from "./AppSettingController";
// import { AuthService } from "angularx-social-login";



export class UserloginController {
	public serviceUrl: string;
	public cookieUrl: string;
	public http: any;
	public router: any;
	public userLoginImplementation: any;
	public static singleInstance: any = null
	public universalService: any;
	loggerService: any;
	localStorageSvc: LocalStorageSvc;
	sessionStorageService: any;
	passPharsaeIsStaySignIn:any
	route;
	loginMode:any=''
	loginCompleted: boolean = false;
	redirectionService:any;
	privateFolderController:any;
	deviceService:any;
	lazyInjectorService:any;
	invitecontroller: InviteLinkController;
	private constructor(public globalService: GlobalService) {
		this.userLoginImplementation = UserLoginImplementation.getInstance(this.globalService);
		this.setEnvObjects(globalService)
	}

	public static getInstance(globalService): UserloginController {
		if (this.singleInstance == null) {
			this.singleInstance = new UserloginController(globalService);
			return this.singleInstance;
		} else {
			return this.singleInstance;
		}
	}

	async routeHandler(destination) {
		document.body.classList.remove('modal-open');
		if(this.universalService.activeRepo == ActiveRepo.MAIN){
			this.globalService.getFolderServiceRef().initialiseBreadCrumbs('1', this.universalService.rootFolderNameNew , null);
		}
		this.lazyInjectScripts();
		if(this.globalService.getRouterRef().url.includes('/pricing') && this.universalService.planPurchaseInitiated){
			this.universalService.disableModalBackdrop();
			await this.userLoginImplementation.getUserDetails();
			let userData = this.localStorageSvc.getUserData(true)
			if(userData["allowStoragePurchase"] == "N" || userData["allowStoragePurchase"] == "D" || this.universalService.purchaseModalType == "JioSim"){
				this.universalService.purchaseModalType = "JioSim";	
			}else{
				this.sessionStorageService.setBuyStorageAlreadyInitiated(true);
				this.globalService.getRouterRef().navigate(["/buystorage"]);
			}
			return
		}
		if(this.globalService.getRouterRef().url.includes('/spinthewheel') || this.globalService.getRouterRef().url.includes('/scratchtowin') || this.globalService.getRouterRef().url.includes('/applycoupon')){
			this.universalService.disableModalBackdrop();
			this.universalService.showLoader = false;
			this.universalService.userLandingLoggedIn = true;
			return
		}
		if (destination == "otp") {
			this.globalService.getRouterRef().navigate(['/']);
		} else if(destination == "loginerror" && window.location.href.includes('/waves')){
			AppEvents.loginSubscriptions.next({"waveRegister":true});
		} else if (destination == "loginerror") {
			this.globalService.getRouterRef().navigate(['/signin']);
		}
		else {
			const inviteKey = this.localStorageSvc.getInviteKey(LocalStorageProps.INVITE_KEY);
			var redirectUrl = this.redirectionService.getRequestedUrlFromLocalStorageWithExpiry(LocalStorageProps.INVITE_URL);
			var redirectUrlPromo =  this.redirectionService.getRequestedUrlFromLocalStorageWithExpiry(LocalStorageProps.REDIRECTION_URL);
			let parsedObject = redirectUrlPromo != "" ? JSON.parse(redirectUrlPromo) : redirectUrlPromo;
			if(window.location.href.includes('/waves')){
				
				let nsmurl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"]
				let dcCode = "jaws"
				if(nsmurl.toLowerCase().includes("jmng2")){
				dcCode = "jmng2"
				}else if(nsmurl.toLowerCase().includes("jmng")){
				dcCode = "jmng"
				}
				let jcJWT = this.localStorageSvc.getLocalProperty(LocalStorageProps.JC_JWT,false);
        		let url = ENV_CONSTANTS["privateUrls"][GlobalClassInstance.ENV_NAME]["eventRegistrationUrl"]+jcJWT+"&dcCode="+dcCode+"&eventId="+this.universalService.eventId
				//this.universalService.eventUserFirstName
				//this.universalService.eventUserLastName
				//this.universalService.eventUserEmail
				//this.universalService.isWaveEvent = true;
				window.open(url, "_self","noopener, noreferrer");
        		return;
				//window.location.href = url;
				//redirectUrlPromo = "https://events-sit.tejdrive.com/user-registered"
			}else 
			if (redirectUrl != "" && inviteKey != "") {
				// if (this.universalService.browserDetails.os.name == "Android" || this.universalService.browserDetails.os.name == "iOS") {
				// 	redirectUrl = redirectUrl + "&mob=true"
				// }
				this.fetchAlbumDetails(inviteKey)
				// window.location.href = redirectUrl;
				
			}else if(redirectUrlPromo != "" && redirectUrlPromo == "promo"){
				window.location.href = "/promo";
				this.redirectionService.removeRequestedUrlFromLocalStorage();
			}else if(redirectUrlPromo != "" && redirectUrlPromo == "/people"){
				this.globalService.getRouterRef().navigate(['/people']);
				this.redirectionService.removeRequestedUrlFromLocalStorage();
			}else if(redirectUrlPromo && redirectUrlPromo == "/dataexport/history"){
				window.location.href = redirectUrlPromo;
				this.redirectionService.removeRequestedUrlFromLocalStorage();
			}else if(redirectUrlPromo && redirectUrlPromo != "" && parsedObject["route"] == "jpai"){
				let folderKey = parsedObject["folderKey"];
				this.redirectionService.removeRequestedUrlFromLocalStorage();
				this.router.navigate(["/jpai"],{queryParams: {jp:folderKey}})
			}else if(redirectUrlPromo && redirectUrlPromo != ""){
				window.location.href = redirectUrlPromo;
				this.redirectionService.removeRequestedUrlFromLocalStorage();
			}else {
				var shareKey = this.sessionStorageService.getObjectWithExpiry(SessionStorageProps.SHARE_KEY_WITH_EXPIRY)
				var grantAccessUrl = this.sessionStorageService.getGrantAccessId();
				var singleObjectShared = this.sessionStorageService.getObjectWithExpiry(SessionStorageProps.SINGLE_SHARED_OBJECT_WITH_EXPIRY);
				var initiateBuyStorage = this.sessionStorageService.getObjectWithExpiry(SessionStorageProps.BUY_STORAGE);
				if (shareKey != "" && shareKey) {
					var link = '/share/?s=' + shareKey;
					this.sessionStorageService.removeSessionProperty(SessionStorageProps.SHARE_KEY_WITH_EXPIRY);
					window.open(link, "_self", "noopener, noreferrer");
				} else {
					if (grantAccessUrl) {
						window.open(grantAccessUrl, "_self", "noopener, noreferrer");
					} else if (singleObjectShared != "") {
						if (this.universalService.activeRepo == 'main') {
							this.globalService.getRouterRef().navigate(['shared/sharedwithme']);
						} else {
							window.location.href = '/shared/sharedwithme'
						}
						this.universalService.setAnimationStatus('Shared');
						this.sessionStorageService.removeSessionProperty(SessionStorageProps.SINGLE_SHARED_OBJECT_WITH_EXPIRY);
					} else if (initiateBuyStorage == "true"){
						this.sessionStorageService.setBuyStorageAlreadyInitiated(true);
						this.globalService.getRouterRef().navigate(['buystorage']);
					}else {
						if (this.universalService.activeRepo == 'main') {
							if(window.location.href.includes('/enterprise/contact-sales') || window.location.href.includes('/enterprise/about')){
								window.location.href = '/home'
							}else{
								this.globalService.getRouterRef().navigate(['home']);
							}	
						} else {
							if(window.location.href.includes('?u=')){   
								this.universalService.fetchLeftMenuJSONContents();
								AppEvents.updateHeaderUI.next({ updateHeaderUI: true });
								this.checkIfShareKeyIsPresentinRouteAndNavigate();
								if(this.universalService.popUpToBeOpened == "addToJioCloud" ){
									let selectedFiles = this.universalService.selectedNodes;
									setTimeout(() => {
										if(USER_DETAILS["USER_DETAILS"]["userId"] == this.sessionStorageService.getShareLinkCreator()){
											AppEvents.optionSelected.next({addToJC: false});
											this.universalService.showToast(TOAST["SHARE_LINK_OWNER_ADD_TO_JC"],"error");
										}else{
											AppEvents.optionSelected.next({addToJC: true, selectedFiles : selectedFiles});
										}
									}, 500);
								}
								if(this.universalService.openCreateShareLink ){
									setTimeout(() => {
										AppEvents.optionSelected.next({showEnhancedShareLink:true});   
									}, 500);
									this.universalService.openCreateShareLink = false;
								}

								AppEvents.emit(EventsList.UNIVERSAL_SHARE_TABBED_VEW);
							}
							else{
								window.location.href = '/home'
							}
						}
					}
	
				}
	
			}
			this.universalService.disableModalBackdrop();
		}
	}
	public async fetchAlbumDetails(inviteKey) {
		this.invitecontroller = InviteLinkController.getInstance(this.globalService);
		this.invitecontroller.setEnvObjects(this.globalService);
		
		const albumDetails = await this.invitecontroller.fetchPublicInviteDetails(inviteKey);
		if (!albumDetails) return;
	
		const userData = this.localStorageSvc.getUserData(true);
		const boardKey = albumDetails.boardKey;
		const usersCount = albumDetails.usersCount;
	
		if (userData && albumDetails.errorCode === "BINVS0054") {
			this.localStorageSvc.removeLocalProperty(LocalStorageProps.INVITE_URL);
			localStorage.setItem('isUserAlreadyPartOfBorad','Y')
			this.redirectToAlbum(boardKey, usersCount);
			return;
		}
	
		const result = await this.invitecontroller.acceptAlbumInvitation();	
		if (!result) return;
	
		if (result.error?.code === "BINVS0054") {
			this.redirectToAlbum(result.boardKey || boardKey, result.usersCount || usersCount);
			localStorage.setItem('isUserAlreadyPartOfBorad','Y')
			return
		}else if(result.error?.code === "BINVS0040"){
			this.localStorageSvc.removeLocalProperty(LocalStorageProps.INVITE_URL);
			setTimeout(()=>{
				this.universalService.showToast(result.error?.error,'error')
			},1000)
			this.redirectToAlbum('', usersCount);
		}
		if (result && !result.error) {
			this.redirectToAlbum(result.boardKey, result.usersCount);
		}
	}
		
	private redirectToAlbum(boardKey: string, usersCount: number) { 
		this.localStorageSvc.removeLocalProperty(LocalStorageProps.INVITE_URL);
		let url ="";
		if(!boardKey){
			url = '/albums' ;
		}else{
			url = usersCount > 0 ? `/albums/sharedalbums/${boardKey}` : `/albums/myalbums/${boardKey}`;
		}
		// if(this.universalService.browserDetails.os.name =="Android" || this.universalService.browserDetails.os.name =="iOS"){
		// 	url = url + "&mob=true";
		// }
		window.location.href = url;
	}
		
	public setEnvObjects(globalService) {
		this.universalService = globalService.getUniversalServiceRef();
		this.globalService = globalService;
		this.loggerService = globalService.getLoggerServiceRef();
		this.localStorageSvc = globalService.getLocalStorageSvcRef();
		this.sessionStorageService = globalService.getSessionStorageSvcRef();
		this.route = globalService.getActivatedRoute();
		this.redirectionService = globalService.getRedirectionServiceRef();
		this.router = globalService.getRouterRef();
		this.deviceService =  globalService.getDeviceServiceRef();
		this.lazyInjectorService = globalService.getLazyInjectorServiceRef();
	}

	public async validate2FA() {
		var userData = this.localStorageSvc.getUserData(true);
		this.universalService.showLoader = true; 
		this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]+  ENV_CONFIG.commonUrls["validate2fa"];
		try {
			let result = await this.userLoginImplementation.validate2FA(this.serviceUrl);
			if(result == 'Success'){
				if(this.router.url == ('/') || this.globalService.getRouterRef().url.includes('/pricing') || window.location.href.includes('/share/?s')
				|| window.location.href.includes('?u') || this.globalService.getRouterRef().url.includes('promotions/scratchtowin')|| this.globalService.getRouterRef().url.includes('promotions/spinthewheel')
				|| (sessionStorage.getItem('redirectedRoute') == null && this.globalService.getRouterRef().url == "/") || this.globalService.getRouterRef().url.includes('/downloadApp') || this.globalService.getRouterRef().url.includes('/features') || this.globalService.getRouterRef().url.includes('/signin') || window.location.href.includes('?login') || window.location.href.includes('/enterprise/contact-sales') || window.location.href.includes('/enterprise/about') || this.router.url.includes('/clbkinweb')){
					if(window.location.href.includes('?u')){
						await this.userLoginImplementation.getUserDetails();
						this.handlePassPharseLogin();
					}else{
						this.handlePassPharseLogin();
					}
				}else{
					this.universalService.show2FApopUp = false;
					//decide to play memory if passphrase success
					this.universalService.decideMemoryTimer();
					
					
					var route = sessionStorage.getItem('redirectedRoute');
					if((route != undefined && route != null)){
						sessionStorage.removeItem('redirectedRoute')
						if(this.globalService.getRouterRef().url.includes('familyshare/invite')){
							let inviteKey = localStorage.getItem('familyShareInviteKey')
							this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
   							this.router.navigate(['/familyshare/invite'],{queryParams: {ic:inviteKey}}));
						}else{
							if(!this.globalService.getRouterRef().url.includes('?') && !this.globalService.getRouterRef().url.includes('&')){ // added check for query params, it will not consider query params when routing with router.navigate without passing queryParams in the navigation
								this.globalService.getRouterRef().navigate([route])
							}
						}	
					}
					setTimeout(()=>{
						this.universalService.showLoader = false;
					},20)

					if(userData["privateFolder"] && userData["privateFolder"]["allowPPF"]) {
						AppEvents.privateFolderOperations.next({setPFWithPassPhrase: true});
					}
				}
			}
			
		} catch (e) {
			this.universalService.showLoader = false;
			this.loggerService.log("handleLogin exception" + e);
		}
	}

	public async socialLogin(socialplatform: String, browser: any, browserVersion: any,authToken?:any) {
		this.serviceUrl = ENV_CONFIG.commonUrls["socialLoginUrl"];//'/account/login';
		try {
			let authProviderId
			if (socialplatform === 'facebook') {
				authProviderId = ENV_CONFIG.commonUrls.fbAuthProviderId;
			} else if (socialplatform === 'google') {
				authProviderId = ENV_CONFIG.commonUrls.googleAuthProviderId
			}else if (socialplatform === 'apple') {
				authProviderId = ENV_CONFIG.commonUrls.appleAuthProviderId
			}
			let result = await this.userLoginImplementation.socialLogin(this.serviceUrl, socialplatform, browser, browserVersion, authProviderId,authToken);
			this.loginMode = "social";
			if(this.universalService.show2FApopUp){
				return;
			}else{
				
				this.handlePostSocialLoagin()
			}
		} catch (e) {
			if((e.status == 0 && e.statusText == 'Unknown Error') || e.status == 450 || e.error.code == "SCLN0192" || e.error.code == "SCLN0193" || e.error.code == "SCLN0194" || e.error.code == "SCLN0195" || e.error.code == "SCLN0196"){
				this.universalService.showLoader = false;
				return;
			}
			else{
				this.routeHandler("idam");
				this.loggerService.log("handleLogin exception" + e);
			}
		}
	}



	handlePassPharseLogin(){
		this.universalService.disableModalBackdrop();
		if(this.loginMode == "otp"){
			this.handlePostOtpLogin(this.passPharsaeIsStaySignIn);
		}else if(this.loginMode == "social"){
			this.handlePostSocialLoagin();
		}else if(this.loginMode == "qr"){
			this.handlePostQRLogin();
		}else if(this.loginMode == "jiocloudpc"){
			this.handlePostJiocloudpcLogin();
		}else if(this.loginMode == "jioid"){
			this.handlePostJioIdLogin();
		}else {
			this.handlePost2FA()
		}
	}

	async handlePostSocialLoagin(){
		await this.updateAppSettingsForSocialLogin();
		clearInterval(UniversalService.pingcall);
		this.universalService.openLoginPopUp = false;
		this.universalService.show2FApopUp = false;
		this.universalService.userLoggedIn = true;
		this.ping()
		this.routeHandler("success");
	}

	async handlePost2FA(){
		await this.updateAppSettings();
		clearInterval(UniversalService.pingcall);
		this.universalService.show2FApopUp = false;
		this.universalService.userLoggedIn = true;
		this.ping()
		this.routeHandler("success");
	}

	async handlePostJioIdLogin(){
		await this.updateAppSettings();
		clearInterval(UniversalService.pingcall);
		this.universalService.show2FApopUp = false;
		this.universalService.userLoggedIn = true;
		this.ping()
		this.routeHandler("success");
	}

	async handlePostJiocloudpcLogin() {
		await this.updateAppSettings();
		clearInterval(UniversalService.pingcall);
		this.universalService.show2FApopUp = false;
		this.universalService.userLoggedIn = true;
		this.ping()
		this.routeHandler("success");
	}

	async handlePostQRLogin(){
		await this.updateAppSettings();
		clearInterval(UniversalService.pingcall);
		this.universalService.show2FApopUp = false;
		this.universalService.userLoggedIn = true;
		localStorage.setItem("passPhraseValidationSuccess", 'true'); // as we dont show passphrase pop up after logging in with QR code. this is being set to avoid showing passphrase as soon as login using QR
		this.ping()
		this.routeHandler("success");
}
	
	public async updateAppSettings(){
		var self = this;
		let dcGroupCode = this.localStorageSvc.getDCGroupCode(true);
		let settingsController = AppSettingController.getInstance(self.globalService);
		settingsController.populateAPIEndpointsInEnv();
		settingsController.setAppSetting(dcGroupCode);
		return true;
	}
	public async updateAppSettingsForSocialLogin(){
		var self = this;
		let dcGroupCode = this.localStorageSvc.getDCGroupCode(true);
		let settingsController = AppSettingController.getInstance(self.globalService);
		let appSettingImpl = settingsController.appSettingImplementation;
		settingsController.populateAPIEndpointsInEnv();
		settingsController.setAppSetting(dcGroupCode);
		appSettingImpl.callMandatoryAPIsOnPageLoad();
		return true;
	}
	public async updateAppEvent(){
		var self = this;
		let eventUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["appEvent"];
		this.userLoginImplementation.updateAppEvent(eventUrl,this.deviceService.browser,this.deviceService.browser_version)
		
	}

	/**To get an new OTP */
	public getOTP(loginType = 'JioId',loginInputEl,resend) {
		switch(loginType){
			case 'Enterprise':
				this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["pbsURL"] + ENV_CONFIG.commonUrls["getEnterpriseLoginOTP"];
				break;
			case 'JioId':
				this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["pbsURL"] + ENV_CONFIG.commonUrls["getJioIdLoginOTP"];
				break;
			default:
				this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["pbsURL"] + ENV_CONFIG.commonUrls["getNewOtp"];
				break;
		}
		let validationType = loginType == "JioId" ? "mobile" : "email";
		this.userLoginImplementation.getOTPApi(this.serviceUrl,validationType, loginInputEl,resend);
	}


	async verifyJioIdOTP(mobileNumber,otp){ 
		this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["pbsURL"] + ENV_CONFIG.commonUrls["jioIdVerifyOTP"];
		try{	
			let accountsList = await this.userLoginImplementation.verifyJioIdOTP(this.serviceUrl,mobileNumber,otp);
			return accountsList;
		}catch(exc){
			return exc;
		}	
	}


	

	public async otpLogin(loginType = 'JioId',mobileNumber: any, emailId: any, otp: any, isStaySignIn: any, browser: any, browserVersion: any) {
		this.universalService.showRecoverpopUp = false;
		switch(loginType){
			case 'Enterprise':
				this.serviceUrl = ENV_CONFIG.commonUrls["enterpriseOTPLoginURL"];
				break;
			case 'JioId':
				this.serviceUrl = ENV_CONFIG.commonUrls["enterpriseOTPLoginURL"];
				break;
			default:
				this.serviceUrl =  ENV_CONFIG.commonUrls["otplLoginUrl"];
				break;
		}

		this.serviceUrl = this.serviceUrl.includes(".com") ? this.serviceUrl.split(".com")[1] : this.serviceUrl;

		try {
			let result = await this.userLoginImplementation.otplogin(this.serviceUrl, mobileNumber, emailId, otp, isStaySignIn, browser, browserVersion);
			this.loginMode = "otp"
			if(mobileNumber.length > 0 && result.body.recoverData){ //recover testing || !result.body.recoverData)
				return;
			}else if(this.universalService.show2FApopUp){
				this.passPharsaeIsStaySignIn = isStaySignIn
				return
			}else{
				this.handlePostOtpLogin(isStaySignIn)
			}
			
		} catch (e) {
			this.universalService.showLoader = false;
			this.loggerService.log("handleLogin exception" + e);
			for (var i = 1; i < 7; i++) {
				(<HTMLInputElement>document.getElementById('digit' + i)).value = "";
			}
		}
	}

	async handlePostOtpLogin(isStaySignIn){
		await this.updateAppSettings();
		clearInterval(UniversalService.pingcall);
		localStorage.setItem("userType", JSON.stringify({ type: "Jio", obj: "" }));
		this.universalService.show2FApopUp = false;
		this.universalService.userLoggedIn = true;
		if (isStaySignIn)
			this.ping()
		else if (window.location.href.includes("?u"))
			this.ping();
		this.routeHandler("success");
	}

	public ping() {
		this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["ping"];//
		this.userLoginImplementation.ping(this.serviceUrl);
	}

	getCookieValue(name) {
		var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
		if (match) {
			return match[2];
		} else {
			return "";
		}
	}
	public refreshData(enablePingInterval, tabchange, refreshLoad) {
		var self = this;
		let settingsController = AppSettingController.getInstance(self.globalService);
		return new Promise(async function (resolve, reject) {
			self.serviceUrl =  ENV_CONFIG.commonUrls["refreshToken"];
			// self.userLoginImplementation.setHandler(self.responseHandler,self.router, self.http, self.globalService);
			try {
				//let response = await self.userLoginImplementation.refreshData(self.serviceUrl, localStorage.getItem("userType"), localStorage.getItem('lastRefreshTime'), localStorage.getItem('isStaySignIn'));
				let response = await self.userLoginImplementation.refreshData(self.serviceUrl, localStorage.getItem("userType"), localStorage.getItem('lastRefreshTime'), USER_DETAILS["USER_DETAILS"]["isStaySignIn"]);
				if (enablePingInterval) {
					clearInterval(UniversalService.pingcall);
					self.ping();
					if (!tabchange) {
						self.universalService.userLoggedIn = true;
					}
				}
				settingsController.populateAPIEndpointsInEnv(); // this call is for updating the endpoints when the dcgroup code of the logged in user is changed, then the updated DC group code will be returned in the refresh API call for stay signed in cases.
				resolve(true);
			} catch (e) {
				console.log(e)
				if (enablePingInterval) {
					clearInterval(UniversalService.pingcall);
					self.ping();
					if (!tabchange) {
						self.universalService.userLoggedIn = true;
					}
				}
				settingsController.populateAPIEndpointsInEnv(); // this call is for updating the endpoints when the dcgroup code of the logged in user is changed, then the updated DC group code will be returned in the refresh API call for stay signed in cases.
				resolve(true);
			}
		})
	}

	public pingAndCookie() {
		this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["ping"];//
		this.cookieUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["cookieUrl"];
		try {
			this.userLoginImplementation.pingAndCookie(this.serviceUrl, this.cookieUrl);
		} catch (e) {
			this.loggerService.log("handleLogin exception" + e);
		}
	}

	public async getQRImage(browser: any, browserVersion: any) {
		this.serviceUrl =  ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["pbsURL"] + ENV_CONFIG.commonUrls["getQRCodeUrl"];
		let qrLoginUrl = ENV_CONFIG.commonUrls["loginQRCodeUrl"];
		this.userLoginImplementation.createDeviceKey();
		try {
			var resp = await this.userLoginImplementation.getQRImage(this.serviceUrl, browser, browserVersion, qrLoginUrl);
			if(resp){
				UniversalService.qrLoginInterval = setInterval(async () => {
					try{
						await this.userLoginImplementation.qrLogin(qrLoginUrl,browser,browserVersion);
						this.loginMode = "qr";
						this.handlePostQRLogin()
					}catch(err){
						console.log("error in qr login response",err);
					}	
				}, 6000)
			}
		} catch (e) {
			this.universalService.showLoader = false;
			this.loggerService.log("handleLogin exception" + e);
		}
	}

	public async logout(deviceId, isRemoteLogout) {
		this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["logout"];
		try {
			var userData = this.localStorageSvc.getUserData(true);
			deviceId = (deviceId) ? deviceId : userData["deviceKey"];
			var device = userData["devices"].find(dev=>dev["deviceKey"] == deviceId);
			var result = await this.userLoginImplementation.logout(this.serviceUrl, device);
			this.universalService.showFeaturesForEntUsers= false;
			if (deviceId == userData["deviceKey"]) {
				this.clearLocalStorage();
				this.universalService.isTroubledInSigningInFlowOn = false;
				this.universalService.iframeLogin = false;
				$('#custome_backdrop').remove();
				this.universalService.disableModalBackdrop();
				if (this.universalService.player != undefined && this.universalService.player != null) {
					this.universalService.player.stop();
					this.universalService.player.destroy();
				}
				this.universalService.resetValuesBeforeReLogin();
				if(this.universalService.activeRepo == ActiveRepo.ENTERPRISE){
					window.location.href = "/";
				}else{
					this.globalService.getRouterRef().navigate(['/']);
				}
			}
			if(isRemoteLogout) {
				return true;
			}
		} catch (e) {
			if(isRemoteLogout) {
				return false;
			}
			this.clearLocalStorage();//localStorage.clear();
			this.globalService.getRouterRef().navigate(['/']);
			this.loggerService.log("logout exception" + e);
		}


	}


	public otpValidation(fromId, toId, e,id="digit") {
		this.userLoginImplementation.validateOTP(fromId, toId, e,id);
	}


	public async jioIdLogin(accountDetails,browser,browserVersion,staySignedIn){ 
		this.serviceUrl = ENV_CONFIG.commonUrls["jioIdLoginUrl"];
		try {
			let result = await this.userLoginImplementation.jioIdLogin(this.serviceUrl,accountDetails,browser,browserVersion,staySignedIn);
			this.loginMode = "jioid";
			if(!this.router.url.includes("/waves") && this.universalService.show2FApopUp){
				return;
			}else{
				this.handlePostJioIdLogin()
			}
		} catch (e) {
			this.routeHandler("loginerror");
			this.loggerService.log("handleLogin exception" + e);
		}
	}

	public async jioMartLogin(accountDetails,browser,browserVersion){
		this.serviceUrl = ENV_CONFIG.commonUrls["jioMartLoginUrl"];
		try {
			let result = await this.userLoginImplementation.jioMartLogin(this.serviceUrl,accountDetails,browser,browserVersion,"jioid");
			return result;
		} catch (e) {
			this.loggerService.log("handleLogin exception" + e);
		}
	}


	public async validateJioIdSSOToken(ssotoken,browser,browserVersion){
		this.serviceUrl = ENV_CONFIG.commonUrls["jioIdValidateSSO"];
		try {
			let authProviderId
			authProviderId = ENV_CONFIG.commonUrls.jioIdAuthProviderId;
			let result = await this.userLoginImplementation.validateJioIdSSOToken(this.serviceUrl,ssotoken, authProviderId,browser,browserVersion,"jioid");
			return result;
		} catch (e) {
			this.loggerService.log("handleLogin exception" + e);
			return null
		}
	}


	public async validateJioMartSSOToken(ssotoken,jiomartToken,txnId){
		this.serviceUrl = ENV_CONFIG.commonUrls["jioMartValidateSSO"];
		try {
			let result = await this.userLoginImplementation.validateJioMartSSOToken(this.serviceUrl,ssotoken, jiomartToken,txnId);
			return result;
		} catch (e) {
			this.loggerService.log("handleLogin exception" + e);
			return null
		}
	}




	public async jiocloudpcLogin(token,browser,browserVersion){
		localStorage.removeItem(LocalStorageProps.JIO);
		this.serviceUrl = ENV_CONFIG.commonUrls["jiocloudpcLoginUrl"];
		try {
			let authProviderId
			authProviderId = ENV_CONFIG.commonUrls.jiocloudpcAuthProviderId;
			let result = await this.userLoginImplementation.jiocloudpcLogin(this.serviceUrl,token, authProviderId,browser,browserVersion,"jiocloudpc");
			this.loginMode = "jiocloudpc"
			if(this.universalService.show2FApopUp){
				return;
			}else{
				this.handlePostJiocloudpcLogin()
			}
		} catch (e) {
			this.routeHandler("loginerror");
			this.loggerService.log("handleLogin exception" + e);
			this.universalService.showToast(e.error.error, 'error');
		}
	}

	async twoFALogout(){
		this.universalService.showFeaturesForEntUsers= false;
		this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["twoFALogout"];
		try {
			var checkLogin =localStorage.jio;
			if(!checkLogin){
				this.logoutUsing2Fa();
			}else{
				await this.userLoginImplementation.twoFALogout(this.serviceUrl);
				this.logoutUsing2Fa();
			}
		} catch (e) {
			localStorage.clear();
			this.globalService.getRouterRef().navigate(['/']);
			this.loggerService.log("logout exception" + e);
		}
	}

	async logoutUsing2Fa(){
		this.universalService.showFeaturesForEntUsers= false;
		let inviteKey = this.localStorageSvc.getInviteKey(LocalStorageProps.INVITE_KEY);
		if(localStorage.getItem("univSharelinkSessionID") == null){
			localStorage.clear();
		  }else{
			this.clearLocalStorage()
		  }
		this.universalService.show2FApopUp = false;
		this.universalService.userLandingLoggedIn = false;
		this.universalService.userLoggedIn = false;
		$('#custome_backdrop').remove();
		this.universalService.disableModalBackdrop();
		this.userLoginImplementation.invalidPassPhraseCounter = ENV_CONSTANTS["constants"]["passPhraseattempts"];
		if (this.universalService.player != undefined && this.universalService.player != null) {
			this.universalService.player.stop();
			this.universalService.player.destroy();
		}
		this.universalService.resetValuesBeforeReLogin();
		this.checkIfShareKeyIsPresentinRouteAndNavigate();
		this.checkIfInviteKeyIsPresentinRouteAndNavigate();
	}

	async getAutoLogionToken(){
		//for type specefic url add  "?type=promo"; to service url
		this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["getAutoLoginToken"]; //get normal url with token
		try {
			let result = await this.userLoginImplementation.getAutoLogionToken(this.serviceUrl);
			return result;
		} catch (e) {
			this.loggerService.log("login exception" + e);
		}
	}

	async validateDirectLoginToken(userData, deviceKey){
		this.serviceUrl = ENV_CONFIG.commonUrls["validateAccessToken"];
		try {
			let result = await this.userLoginImplementation.validateDirectLoginToken(this.serviceUrl,userData, deviceKey);
			return result;
		} catch (e) {
			this.loggerService.log("login exception" + e);
		}
	}

	public async recoverAccount(mobileNumber) {
		this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["recoverAccount"];
		try {
			let param = {
				"mobileNumber":mobileNumber
			}
			let recoverResult = await this.userLoginImplementation.recoverAccount(this.serviceUrl, param);
			this.userLoginImplementation.emailId = recoverResult.body.recoverData
			return;
		} catch (e) {
			this.universalService.showLoader = false;
		}
	}

	async sendOTPForRecoverAccount(emailId){
		this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]+  ENV_CONFIG.commonUrls["recoverAccountSendOTP"];
		try {
			let param = {
				"emailId":emailId
			}
			let result = await this.userLoginImplementation.sendOTPForRecoverAccount(this.serviceUrl,param);
			return result;
		} catch (e) {
			this.loggerService.log("login exception" + e);
		}
	}

	async validateOTPForRecoverAccount(emailId,otp){
		let userData = this.localStorageSvc.getUserData(true)
		this.serviceUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]+  ENV_CONFIG.commonUrls["recoverAccountValidateOTP"]; 
		try {
			let param = {
				"emailId":emailId,
				"otp":otp
			}
			let result = await this.userLoginImplementation.validateOTPForRecoverAccount(this.serviceUrl,param);
			if(!this.userLoginImplementation.isOTPLoginError){
				await this.logout(userData["deviceKey"], false);
				await localStorage.clear();

			}
		} catch (e) {
			this.universalService.showLoader = false;
			this.loggerService.log("handleLogin exception" + e);
			for (var i = 1; i < 7; i++) {
				(<HTMLInputElement>document.getElementById('digit' + i)).value = "";
			}
		}
	}
	async troubledLogin(mobileNumber){
		this.serviceUrl =  ENV_CONFIG.commonUrls["troubleLogin"];
		try {
			let result = await this.userLoginImplementation.troubledLogin(this.serviceUrl,mobileNumber);
			return result;
		} catch (e) {
			this.loggerService.log("login exception" + e);
		}
	}

	clearLocalStorage() {
		this.universalService.userLoggedIn = false;
      	localStorage.removeItem(LocalStorageProps.TWOFA_ENABLED);
		localStorage.removeItem(LocalStorageProps.JIO);
		localStorage.removeItem(LocalStorageProps.BANNER_DETAILS);
		localStorage.removeItem("atoken"); // clear token for google account
		localStorage.removeItem(LocalStorageProps.MEDIA_STREAM_TOKEN_TIME); // clear streaming token
		localStorage.removeItem("userType");
		localStorage.removeItem(LocalStorageProps.PROFILE_PHOTO);
		localStorage.removeItem(LocalStorageProps.PROFILE_PHOTO_WITH_APIKEY);
		localStorage.removeItem(LocalStorageProps.RECOVER_DATA);
		localStorage.removeItem(LocalStorageProps.UNIV_SHARELINK_SESSION_ID);
		localStorage.removeItem(LocalStorageProps.UNIV_SHARELINK_SHAREKEY);
		sessionStorage.removeItem(SessionStorageProps.CURRENT_PRIVATE_FOLDER_KEY);
		localStorage.removeItem(LocalStorageProps.PRIVATE_FOLDER_KEY);
		sessionStorage.removeItem(SessionStorageProps.PRIVATE_FOLDER_PASSWORD_TIME);
		localStorage.removeItem(LocalStorageProps.PRIVATE_FOLDER_PASSWORD);
		localStorage.removeItem("entTourMainRepoNoadminSeen");
		localStorage.removeItem("passPhraseValidationSuccess");
		localStorage.removeItem(LocalStorageProps.JC_JWT);

		let imagesExists = this.localStorageSvc.getShareImageExists(true);
		let audiosExists = this.localStorageSvc.getShareAudiosExists(true);
		let videosExists = this.localStorageSvc.getShareVideosExists(true);
		let othersExists = this.localStorageSvc.getShareOthersExists(true);

		this.localStorageSvc.setImageExists(imagesExists, true);
		this.localStorageSvc.setAudiosExists(audiosExists, true);
		this.localStorageSvc.setVideosExists(videosExists, true);
		this.localStorageSvc.setOthersExists(othersExists, true)
		localStorage.removeItem('listViewSortOrderShare');
		localStorage.removeItem('listViewSortOrder');

	}


	async versionAPI(){
		this.serviceUrl = ENV_CONFIG.commonUrls['getVersionDetails'];
		try {
			let result = await this.userLoginImplementation.versionAPI(this.serviceUrl);
			if(result){
				return result;
			}
		} catch (e) {
			console.log("error in getting details from version API",e);
			return null;
		}
	}

	async disconnectMSOffice(consent){
		var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"]+  ENV_CONFIG.commonUrls["getUserDetails"];
		try{
			let disconnected = await this.userLoginImplementation.disconnectMSOffice(url,consent);
			return disconnected;
		}catch(err){
			return err;
		}
	
	  }
	lazyInjectScripts(){
		if(this.universalService.activeRepo == ActiveRepo.MAIN){
			this.lazyInjectorService.LazyInjectJSScripts('swiper');
			this.lazyInjectorService.LazyInjectJSScripts('multiselect');
			if(this.universalService.isMobileDevice){
				this.lazyInjectorService.LazyInjectJSScripts('longpress');
			}
			this.lazyInjectorService.LazyInjectJSScripts("clappr");
			setTimeout(() => {
				this.lazyInjectorService.LazyInjectJSScripts("levelselector");
			}, 1);
		}
	}

	public getCookie() {
		var userCookieExist = this.sessionStorageService.getuserCookieExist();
		if(userCookieExist == null){
			this.cookieUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["cookieUrl"];
			try {
				this.userLoginImplementation.getCookie(this.cookieUrl);
			} catch (e) {
				this.loggerService.log("getCookie exception" + e);
			}
		}
	}


	checkIfShareKeyIsPresentinRouteAndNavigate(){
		if(this.universalService.activeRepo == ActiveRepo.SHARE){
			const sharekey = this.route.snapshot.queryParamMap.get('u');
			if(sharekey){
				this.router.navigate(['/'], { queryParams: { u: sharekey } }); // redirect back to share page after login
			}else{
				window.location.href = "/";
			}
		}else if(this.universalService.activeRepo == ActiveRepo.MAIN){
			this.router.navigate(["/"]);
		}
	}
	checkIfInviteKeyIsPresentinRouteAndNavigate(){
		const invitekey = this.route.snapshot.queryParamMap.get('c');
		if(invitekey){
			let url = environment.baseUrl + "/i/?c=" + invitekey;
			window.location.href = url; // redirect back to invite page after login
		}else{
			window.location.href = environment.baseUrl;
		}
	}
}

